import IconProfileTH from 'components/icons/profile';

export const NAV_LINK_ACCOUNT_ICON_COMPONENT = IconProfileTH;
